import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { BYPASS_HANDLE_ERROR, BYPASS_INTERCEPTOR } from '../../../../shared/service/lottery/users.service';
import { CognitoService } from '../services/cognito.service';
import { DialogsService } from '../../../../shared/service/dialogs.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  get token(): string {
    return localStorage.getItem('rbac-token')! === null || typeof localStorage.getItem('rbac-token') === undefined ? '' : localStorage.getItem('rbac-token')!;
  }

  get tenantId(): string | null {
    return localStorage.getItem("cId") || null;
  }

  public constructor(
    private cognitoService: CognitoService,
    private dialogsService :DialogsService
  ) {}


  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const terminalId = localStorage.getItem('TId');  // Obtenemos el terminalId del servicio
    const bankId = localStorage.getItem('BId');  // Obtenemos el terminalId del servicio
    if (request.context.get(BYPASS_INTERCEPTOR) === true) {
      return next.handle(request); // Omitir interceptor
    }
    // Comienza con los encabezados de la solicitud original
    let headers = request.headers;

    if(!this.tenantId){
      return next.handle(request);
    }

    headers = headers.set('Tenant', this.tenantId);

    if (this.token.trim()) {
      headers = headers.set('Authorization', `Bearer ${this.token.trim()}`);
    }

    let requestClone = request.clone({
      headers
    });

    // Verificamos si la URL contiene ':terminalId' para reemplazarla
    if (request.url.includes(':terminalId') && terminalId) {
      const updatedUrl = request.url.replace(':terminalId', terminalId);  // Reemplazamos la variable en la URL

      // Clonamos la solicitud con la nueva URL
      requestClone = requestClone.clone({
        url: updatedUrl
      });

      return next.handle(requestClone).pipe(
        catchError((error: HttpErrorResponse) => {
          if (request.context.get(BYPASS_HANDLE_ERROR) === false) {
            this.handleError(error);
          }
          // Continuar con un Observable después de manejar el error
          return throwError(() => error);
        })
      );
    }

    if (request.url.includes(':bankId') && bankId) {
      const updatedUrl = request.url.replace(':bankId', bankId);  // Reemplazamos la variable en la URL

      // Clonamos la solicitud con la nueva URL
      requestClone = requestClone.clone({
        url: updatedUrl
      });

      return next.handle(requestClone).pipe(
        catchError((error: HttpErrorResponse) => {
          if (request.context.get(BYPASS_HANDLE_ERROR) === false) {
            this.handleError(error);
          }
          // Continuar con un Observable después de manejar el error
          return throwError(() => error);
        })
      );
    }

    return next.handle(requestClone).pipe(
      catchError((error: HttpErrorResponse) => {
        if (request.context.get(BYPASS_HANDLE_ERROR) === false) {
          this.handleError(error);
        }
        // Continuar con un Observable después de manejar el error
        return throwError(() => error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    // if (error.status === 401) {
    //   this.cognitoService.signOut()
    // }

    if (error.error && error.error.errorMessage) {
      // this.dialogsService.showError(undefined, error.error.errorMessage);
      console.error(error.error.errorMessage)
    } else {
      // this.dialogsService.showError(undefined, error.message);
      console.error(error.message)
    }
    this.dialogsService.closeLoader()

    // Re-lanzar el error para ser manejado localmente si es necesario
    return throwError(() => error);
  }
}
